const index_axios = await import(`./index.js?v=${Date.now()}`);
const {
 axios
} = index_axios;
const get_sections = await import(`./get-sections.js?v=${Date.now()}`);
const {
 getCartSectionsToRender
} = get_sections;

import "./_commonjsHelpers.js";
import "./recommended-products.js";
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    const url = new URL(window.location.href);
    url.searchParams.append("sections", getCartSectionsToRender().map((section) => section.section).join(","));
    axios.get(url.href).then((response) => {
      const newRenderedSectionsObject = response.data;
      const sectionObjects = Object.keys(newRenderedSectionsObject).map((key) => ({
        name: key,
        html: newRenderedSectionsObject[key]
      }));
      sectionObjects.forEach((renderedSection) => {
        var _a;
        const parser = new DOMParser();
        const destinationSelector = (_a = getCartSectionsToRender().find((sectionInfo) => sectionInfo.section == renderedSection.name)) == null ? void 0 : _a.selector;
        const destinationElement = document.querySelector(destinationSelector);
        const rawSectionData = parser.parseFromString(renderedSection.html, "text/html");
        const newSectionElement = rawSectionData.querySelector(destinationSelector);
        if (destinationElement) {
          destinationElement.innerHTML = newSectionElement.innerHTML;
        }
      });
    });
  }
}, false, { passive: true });
